export default __webpack_public_path__ + "static/media/version-history-active.7b42c17d.svg";